const commit = process.env.REACT_APP_BUILD_COMMIT ? process.env.REACT_APP_BUILD_COMMIT : '<unknown>';
const branch = process.env.REACT_APP_BUILD_BRANCH ? process.env.REACT_APP_BUILD_BRANCH : '<unknown>';

window.printBuildInfo = () => {
  // eslint-disable-next-line no-console
  console.log(`Commit: ${commit}, branch: ${branch}`);
};
